import React, { useState } from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TrashIcon from "../../Icons/TrashIcon";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router/TrashConsignemntRouter";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { orderRemarksValidationForm } from "../../utils/validationSchemas";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import { PermissionRequired } from "@careinfo/permission-required";

const TrashOrderListComponent = loadable(
  () => import("../../components/TrashOrder/TrashOrderList")
);

const TrashOrderList = () => {
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const commentMethods = useForm({
    defaultValues: {
      comment: null,
    },
    resolver: yupResolver(orderRemarksValidationForm),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
  });
  const { data, isLoading: isGettingData } = useGetHook({
    url: `${APIS.USER_PROFILE}`,
    queryKey: ["user-profile"],
    params: {},
  });

  const handleUndoDelete = async (
    values,
    id: any,
    setError,
    clearErrors: any
  ) => {
    const comment = values?.comment;
    if (!comment) {
      return setError("comment", {
        type: "validate",
        message: "Comment is required",
      });
    }
    const deleteURL = `${APIS.ORDER}restore/`;
    try {
      const res = await mutateAsync({
        url: deleteURL,
        formData: {
          id: id,
          comment: comment,
        },
        setError,
      });
      if (res?.status === 200) {
        queryClient.refetchQueries();
        setOpenDeletePopup(false);
      }
    } catch (e) {
      if (e instanceof Error) toast.error(e.message);
    }
  };
  return isGettingData ? (
    <Spinner />
  ) : !data?.is_superuser ? (
    <PermissionRequired />
  ) : (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <TrashIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Trash Order
        </span>
      </div>
      <TrashOrderListComponent
        handleUndoDelete={handleUndoDelete}
        isLoading={isPostLoading}
        openDeletePopup={openDeletePopup}
        setOpenDeletePopup={setOpenDeletePopup}
        commentMethods={commentMethods}
        resetComment={() => commentMethods.reset({ comment: null })}
      />
    </>
  );
};

export default TrashOrderList;
